import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "lotto-wrapper",
  class: "contents-wrapper"
}
const _hoisted_2 = { id: "lotto-result-check" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "rv-head" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "rv-title" }, "당첨 결과"),
  /*#__PURE__*/_createElementVNode("p", { class: "rv-sub" }, "회차별 공식 당첨번호·당첨금을 확인하고, 내 번호가 당첨됐는지 판정해 보세요.")
], -1)
const _hoisted_4 = { class: "section-card result-browser" }
const _hoisted_5 = { class: "result-wrapper" }
const _hoisted_6 = { class: "lotto-result-wrapper" }
const _hoisted_7 = { class: "lotto-result-container" }
const _hoisted_8 = { class: "drw-dropdown-wrapper" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "drw-item-no" }
const _hoisted_11 = { class: "text-area" }
const _hoisted_12 = {
  key: 0,
  class: "prize-table-wrapper"
}
const _hoisted_13 = { class: "prize-table" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "등수"),
    /*#__PURE__*/_createElementVNode("th", null, "당첨자 수"),
    /*#__PURE__*/_createElementVNode("th", null, "1인당 당첨금"),
    /*#__PURE__*/_createElementVNode("th", null, "총 당첨금")
  ])
], -1)
const _hoisted_15 = { class: "rank-cell" }
const _hoisted_16 = { class: "rank-cell-inner" }
const _hoisted_17 = ["data-tip"]
const _hoisted_18 = { class: "amount-cell" }
const _hoisted_19 = { class: "amount-summary" }
const _hoisted_20 = { class: "amount-detail" }
const _hoisted_21 = { class: "amount-cell" }
const _hoisted_22 = { class: "amount-summary" }
const _hoisted_23 = { class: "amount-detail" }
const _hoisted_24 = {
  key: 1,
  class: "win-type-info"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "win-type-label" }, "1등 구매유형", -1)
const _hoisted_26 = {
  key: 0,
  class: "win-type-item"
}
const _hoisted_27 = {
  key: 1,
  class: "win-type-item"
}
const _hoisted_28 = {
  key: 2,
  class: "win-type-item"
}
const _hoisted_29 = {
  key: 3,
  class: "win-type-item unknown"
}
const _hoisted_30 = { class: "section-card" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "내 번호 당첨 확인", -1)
const _hoisted_32 = { class: "section-desc" }
const _hoisted_33 = { class: "my-numbers-input" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "check-rank" }
const _hoisted_37 = { class: "check-matched" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 0,
  class: "check-prize"
}
const _hoisted_40 = { class: "check-numbers" }
const _hoisted_41 = { class: "win-lists-row" }
const _hoisted_42 = { class: "section-card" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "브리저 최근 당첨", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "브리저에서 만들어 구매한 번호 중 당첨된 내역이에요.", -1)
const _hoisted_45 = {
  key: 0,
  class: "win-hist-list"
}
const _hoisted_46 = { class: "wh-balls" }
const _hoisted_47 = { class: "wh-meta" }
const _hoisted_48 = {
  key: 1,
  class: "wh-empty"
}
const _hoisted_49 = {
  key: 2,
  class: "pager"
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "pager-info" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "section-card" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "역대 최고 등수", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "브리저 이용자들이 기록한 역대 최고 순위예요.", -1)
const _hoisted_56 = {
  key: 0,
  class: "win-hist-list"
}
const _hoisted_57 = { class: "wh-balls" }
const _hoisted_58 = { class: "wh-meta" }
const _hoisted_59 = {
  key: 1,
  class: "wh-empty"
}
const _hoisted_60 = {
  key: 2,
  class: "pager"
}
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "pager-info" }
const _hoisted_63 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LottoResult = _resolveComponent("LottoResult")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevDrw())),
                class: "arrow-button prev",
                "aria-label": "이전 회차"
              }),
              _createVNode(_component_LottoResult, { lottoResult: _ctx.result }, {
                drwNo: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", {
                      ref: "drwNoText",
                      class: "drw-no-text",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["stop"]))
                    }, _toDisplayString(_ctx.result.drwNo) + " 회차 ", 513),
                    (_ctx.showDropdown)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "drw-dropdown",
                          style: _normalizeStyle(_ctx.dropdownStyle),
                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drwNoList, (no) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: no,
                              class: _normalizeClass(["drw-dropdown-item", { active: no === _ctx.result.drwNo }]),
                              onClick: ($event: any) => (_ctx.selectDrwNo(no))
                            }, [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(no) + " 회차", 1)
                            ], 10, _hoisted_9))
                          }), 128))
                        ], 4))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["lottoResult"]),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nextDrw())),
                class: "arrow-button next",
                "aria-label": "다음 회차"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.result.prizes && _ctx.result.prizes.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("table", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.prizes, (prize) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: prize.rank,
                          class: _normalizeClass('prize-rank-' + prize.rank)
                        }, [
                          _createElementVNode("td", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, [
                              _createTextVNode(_toDisplayString(prize.rank) + "등 ", 1),
                              _createElementVNode("span", {
                                class: "rank-help",
                                "data-tip": _ctx.rankCondMap[prize.rank],
                                tabindex: "0"
                              }, "?", 8, _hoisted_17)
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getMoneyFormat(prize.winCount)) + "명", 1),
                          _createElementVNode("td", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.getShortenMoney(prize.winAmount)), 1),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.getMoneyFormat(prize.winAmount)) + "원", 1)
                          ]),
                          _createElementVNode("td", _hoisted_21, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.getShortenMoney(prize.totalAmount)), 1),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.getMoneyFormat(prize.totalAmount)) + "원", 1)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasWinType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  (_ctx.result.winType1 > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "자동 " + _toDisplayString(_ctx.result.winType1), 1))
                    : _createCommentVNode("", true),
                  (_ctx.result.winType2 > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "수동 " + _toDisplayString(_ctx.result.winType2), 1))
                    : _createCommentVNode("", true),
                  (_ctx.result.winType3 > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, "반자동 " + _toDisplayString(_ctx.result.winType3), 1))
                    : _createCommentVNode("", true),
                  (_ctx.result.winType0 > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, "미확인 " + _toDisplayString(_ctx.result.winType0), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("p", _hoisted_32, [
          _createTextVNode("위에서 선택한 "),
          _createElementVNode("b", null, _toDisplayString(_ctx.result.drwNo) + "회차", 1),
          _createTextVNode(" 기준으로 내 번호를 판정합니다.")
        ]),
        _createElementVNode("div", _hoisted_33, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
            return _withDirectives(_createElementVNode("input", {
              key: 'mi-' + i,
              type: "number",
              "onUpdate:modelValue": ($event: any) => ((_ctx.myNumbers[i - 1]) = $event),
              class: "number-input",
              min: "1",
              max: "45"
            }, null, 8, _hoisted_34), [
              [
                _vModelText,
                _ctx.myNumbers[i - 1],
                void 0,
                { number: true }
              ]
            ])
          }), 64))
        ]),
        _createElementVNode("button", {
          class: "check-btn",
          disabled: !_ctx.isValidNumbers || _ctx.result.drwNo === 0,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkMyNumbers && _ctx.checkMyNumbers(...args)))
        }, " 판정하기 ", 8, _hoisted_35),
        (_ctx.checkResult !== null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["check-result", 'rank-result-' + _ctx.checkResult.rank])
            }, [
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.checkResult.rank <= 5 ? _ctx.checkResult.rank + '등 당첨!' : '아쉽게도 낙첨'), 1),
              _createElementVNode("div", _hoisted_37, [
                _createTextVNode(" 일치 번호: " + _toDisplayString(_ctx.checkResult.matched) + "개 ", 1),
                (_ctx.checkResult.hasBonus)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, " + 보너스"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.checkResult.prize > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, " 예상 당첨금: " + _toDisplayString(_ctx.formatKRW(_ctx.checkResult.prize)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myNumbers, (num, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'cn-' + i,
                    class: _normalizeClass(["check-ball", [_ctx.getColorClass(num), { matched: _ctx.isMatched(num), bonus: _ctx.isBonusMatch(num) }]])
                  }, _toDisplayString(num), 3))
                }), 128))
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _hoisted_44,
          (_ctx.winRecent.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.winRecent, (g, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'wr-' + idx,
                    class: "win-hist-item"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["wh-rank", 'rank-' + g.rank])
                    }, _toDisplayString(g.rank) + "등", 3),
                    _createElementVNode("div", _hoisted_46, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameNumbers(g), (num, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'wrb-' + idx + '-' + i,
                          class: _normalizeClass(["wh-ball", _ctx.getColorClass(num)])
                        }, _toDisplayString(num), 3))
                      }), 128))
                    ]),
                    _createElementVNode("span", _hoisted_47, _toDisplayString(g.drwNo) + "회 · " + _toDisplayString(g.nickname || '익명'), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_48, "아직 당첨 내역이 없어요.")),
          (_ctx.winRecentTotalPages > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("button", {
                  class: "pager-btn",
                  disabled: _ctx.winRecentPage <= 1,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fetchWinRecent(_ctx.winRecentPage - 1)))
                }, "이전", 8, _hoisted_50),
                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.winRecentPage) + " / " + _toDisplayString(_ctx.winRecentTotalPages), 1),
                _createElementVNode("button", {
                  class: "pager-btn",
                  disabled: _ctx.winRecentPage >= _ctx.winRecentTotalPages,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchWinRecent(_ctx.winRecentPage + 1)))
                }, "다음", 8, _hoisted_52)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _hoisted_55,
          (_ctx.bestPageItems.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bestPageItems, (g, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'bp-' + idx,
                    class: "win-hist-item"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["wh-rank", 'rank-' + g.rank])
                    }, _toDisplayString(g.rank) + "등", 3),
                    _createElementVNode("div", _hoisted_57, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameNumbers(g), (num, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'bpb-' + idx + '-' + i,
                          class: _normalizeClass(["wh-ball", _ctx.getColorClass(num)])
                        }, _toDisplayString(num), 3))
                      }), 128))
                    ]),
                    _createElementVNode("span", _hoisted_58, _toDisplayString(g.drwNo) + "회 · " + _toDisplayString(g.nickname || '익명'), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_59, "아직 기록이 없어요.")),
          (_ctx.bestTotalPages > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createElementVNode("button", {
                  class: "pager-btn",
                  disabled: _ctx.bestPage <= 1,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.bestPage--))
                }, "이전", 8, _hoisted_61),
                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.bestPage) + " / " + _toDisplayString(_ctx.bestTotalPages), 1),
                _createElementVNode("button", {
                  class: "pager-btn",
                  disabled: _ctx.bestPage >= _ctx.bestTotalPages,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.bestPage++))
                }, "다음", 8, _hoisted_63)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}